/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PassportParams { 
    /**
     * Id Hash. UUI (Unique User Identifier). Maximum lenght 88.
     */
    idHashUser?: string;
    /**
     * Country code in ISO-ALPHA-3
     */
    countryCode?: string;
    /**
     * Espedition Date of the passport. Format yyyy-MM-dd
     */
    expeditionDate?: string;
    /**
     * Not after Date of the passport. Format yyyy-MM-dd
     */
    notAfterDate?: string;
    /**
     * Identification Number found in the passport
     */
    identificationNumber?: string;
    /**
     * Passport number
     */
    passportNumber?: string;
    /**
     * Nationality or nationalities that appear in the passport and in the same format
     */
    nationality?: string;
    /**
     * Document Type
     */
    type?: string;
}

